import store from '@/store'
import { compressJsonToGzip } from '@/util/gzipCompress'
import OSS from 'ali-oss'
import { nanoid } from 'nanoid'
import Vue from 'vue'

export async function uploadFiles(obj: any, callback: any, errCallback?: any) {
  const uid = store.state.userInfo.id
  const time = new Date()
  // 对 /bluenMaterialData 目录下的 json 文件进行 gzip压缩
  const compressedBlob = await compressJsonToGzip(obj)
  const path = `/bluenMaterialData/${uid}/${time.getTime()}_${nanoid()}.json.gz`
  const file = new File([compressedBlob], path, {
    type: '',
    lastModified: Date.now(),
  })
  await Vue.prototype.$getByToken('/get_oss_token', {}, (res: any) => {
    if (res.status == 1) {
      const client = new OSS({
        region: 'oss-cn-hangzhou',
        accessKeyId: res.data.AccessKeyId,
        accessKeySecret: res.data.AccessKeySecret,
        stsToken: res.data.SecurityToken,
        bucket: 'eggrj',
      })
      client
        .multipartUpload(path, file, {
          headers: {
            'Content-Type': 'application/json',
            'Content-Encoding': 'gzip',
          },
        })
        .then(() => {
          const url = 'https://eggrj.oss-cn-hangzhou.aliyuncs.com' + path
          callback(url)
        })
        .catch((err) => {
          console.error(err)
          errCallback && errCallback()
          Vue.prototype.$message({
            type: 'error',
            message: '<span id="material_upload_error">上传失败!</span>',
            duration: 1500,
            offset: 60,
            dangerouslyUseHTMLString: true,
          })
        })
    }
  })
}

/**
 * 上传已压缩的文件到 bluenMaterialData 目录
 * @param file 已压缩的 File 对象
 * @param customPath 自定义路径（可选），如果不提供则使用日期格式路径
 * @returns Promise<string> 返回上传后的 URL
 */
export async function uploadCompressedFile(
  file: File,
  customPath?: string
): Promise<string> {
  return new Promise((resolve, reject) => {
    Vue.prototype.$getByToken('/get_oss_token', {}, (res: any) => {
      if (res.status == 1) {
        const client = new OSS({
          region: 'oss-cn-hangzhou',
          accessKeyId: res.data.AccessKeyId,
          accessKeySecret: res.data.AccessKeySecret,
          stsToken: res.data.SecurityToken,
          bucket: 'eggrj',
        })
        // 构建 OSS 路径
        let ossPath: string
        if (customPath) {
          ossPath = customPath
        } else {
          // 按照 uploadFile 的规则构建路径（日期格式）
          const time = new Date()
          const dateStr = `${time.getFullYear()}_${String(
            time.getMonth() + 1
          ).padStart(2, '0')}_${String(time.getDate()).padStart(2, '0')}`
          ossPath = `/bluenMaterialData/${dateStr}/${file.name}`
        }
        client
          .multipartUpload(ossPath, file, {
            headers: {
              'Content-Type': 'application/json',
              'Content-Encoding': 'gzip',
            },
          })
          .then(() => {
            const url = 'https://eggrj.oss-cn-hangzhou.aliyuncs.com' + ossPath
            resolve(url)
          })
          .catch((err) => {
            console.error(err)
            reject(err)
          })
      } else {
        reject(new Error('获取 OSS token 失败'))
      }
    })
  })
}
